import { render, staticRenderFns } from "./Unissued.vue?vue&type=template&id=0085041a&scoped=true"
import script from "./Unissued.vue?vue&type=script&lang=js"
export * from "./Unissued.vue?vue&type=script&lang=js"
import style0 from "./Unissued.vue?vue&type=style&index=0&id=0085041a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085041a",
  null
  
)

export default component.exports